import React from "react";
import "./Footer.css";
import { ThemeContext } from "../../Context/theme";
//import img from "../../Assets/R_logo.png";

export const Footer = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
   {/* <img className="image_size"
                src={img}
                alt="Images"
              /> */}
      <div className={"section " + themename}>
        <a href="https://github.com/ruchipriya1009" rel="noreferrer" target="_blank">
          <h4 className="footer"><span id="ch">Made by </span>: 
          Ruchi Priya Kumari</h4>
        </a>
      </div>
    </>
  );
};
